import axios from 'axios';
import {
  logOutAuthPath,
  loginAuthPath,
} from '../utils/endpoints';
import { CreateDataByIndexedDB, GetAllDataByIndexedDB } from '../indexed';
import axiosInstance from '../helpers/interceptor';
import { userHotelDetails } from '../helpers/handleBrandAndHotelData';
import { authMe } from './../utils/endpoints';
import { getItem } from '../utils/localStorage';

export const loginUser = async (
  username: string,
  phone: string | number,
  password: string,
  isLogoutOther?: boolean
) => {
  // Use getItem (not raw localStorage) so the sent value matches what /auth/me presents.
  const sessionId = getItem('sessionId');
  const payload: any = {
    password,
  };
  if (phone) {
    payload.userphone = phone.toString().startsWith('+')
      ? phone.toString()
      : `+${phone}`;
  } else if (username) {
    payload.username = username.trim().toLowerCase();
  }
  if (sessionId) {
    payload.sessionid = sessionId;
  }
  if (isLogoutOther) {
    payload.islogoutother = isLogoutOther;
  }
  return await axios.post(loginAuthPath, payload);
};

export const logOutUser = async (accessToken) => {
  return await axios.get(logOutAuthPath, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

export const getTemplateData = async (id: string, user: any) => {
  const { selectedHotel } = userHotelDetails();

  const path = `${Env.API_URL}/template/${id}?isClientApp=true`;
  const OfflineData = await GetAllDataByIndexedDB(
    `/template/${id}`,
    selectedHotel
  );
  if (OfflineData) {
    return OfflineData;
  }
  const { data } = await axiosInstance.get(path);
  CreateDataByIndexedDB(`/template/${id}`, data, selectedHotel);

  return data;
};

export const authMeAPI = async (token) => {
  const { data } = await axios.get(`${authMe}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return data;
};
